/* eslint-disable */
// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  openMsg: false,
  messageData: null,
  userData: null,
  loader: false,
  report: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
    setOpenMsg: (state, { payload }) => {
      state.openMsg = true;
      state.messageData = payload;
    },
    setCloseMsg: (state, { payload }) => {
      state.openMsg = payload;
      state.messageData = null;
    },
    setUserData: (state, { payload }) => {
      state.userData = payload;
    },
    updateEmail: (state, { payload }) => {
      state.userData = payload;
    },
    setReport: (state, { payload }) => {
      state.report = payload;
    },
    removeUserData: (state, {}) => {
      localStorage.removeItem('user/setUserData');
      localStorage.removeItem('user/updateEmail');
      state.userData = null;
    },
  },
});

export const userSliceCachedActions = ['user/setUserData', 'user/updateEmail'];
export const {
  setOpenMsg,
  setCloseMsg,
  setUserData,
  updateEmail,
  removeUserData,
  setLoader,
  setReport,
} = userSlice.actions;

export const userReducer = userSlice.reducer;
